import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import Input from "../../../../componentes/input/input";
import Button from "../../../../componentes/button/button";
import { acaoInfo } from "../../../../utils/solicitacoes/statusConfig";

// Etapa "Análise do Financeiro" — três desfechos: Aprovar (mantém limite/prazo exatamente como
// propostos), Aprovar Parcial (financeiro informa um limite e/ou prazo diferente do solicitado) ou
// Reprovar. Justificativa obrigatória nos três casos. Os campos de aprovação parcial ficam sempre
// visíveis (não só depois de escolher a ação) para o financeiro já poder preenchê-los antes de
// decidir, mas só são exigidos de fato quando a ação enviada é "Aprovar Parcial".
export default function EtapaLimitePrazoAnaliseFinanceiro({ acoes = [], acaoEmExecucao, onExecutarAcao, detalheProcesso }) {
    const [justificativa, setJustificativa] = useState("");
    const [limiteAprovado, setLimiteAprovado] = useState("");
    const [prazoAprovado, setPrazoAprovado] = useState("");

    const tipoSolicitacao = detalheProcesso?.tipoSolicitacao;
    const exigeLimite = tipoSolicitacao === "LIMITE" || tipoSolicitacao === "AMBOS";
    const exigePrazo = tipoSolicitacao === "PRAZO" || tipoSolicitacao === "AMBOS";
    const podeAprovarParcial = acoes.includes("APROVAR_PARCIAL");

    function executar(acao) {
        if (!justificativa.trim()) return;
        if (acao === "APROVAR_PARCIAL") {
            if (exigeLimite && !limiteAprovado) return;
            if (exigePrazo && !prazoAprovado) return;
        }
        const dados = { justificativaAnalise: justificativa.trim() };
        if (acao === "APROVAR_PARCIAL") {
            if (exigeLimite) dados.limiteAprovado = Number(limiteAprovado);
            if (exigePrazo) dados.prazoAprovado = Number(prazoAprovado);
        }
        onExecutarAcao(acao, { dados });
    }

    const parcialDesabilitado = !justificativa.trim()
        || (exigeLimite && !limiteAprovado)
        || (exigePrazo && !prazoAprovado);

    return (
        <div className="flex flex-col gap-4">
            <Textarea label="Justificativa da análise" required value={justificativa} onChange={e => setJustificativa(e.target.value)} rows={3} />

            {podeAprovarParcial && (exigeLimite || exigePrazo) && (
                <div className="border-t border-border pt-4 flex flex-col gap-3">
                    <div>
                        <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Aprovação parcial</h4>
                        <p className="text-xs text-muted-foreground mt-1">Preencha só se for aprovar um valor diferente do solicitado pelo cliente.</p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {exigeLimite && (
                            <Input type="number" min="0" step="0.01" label="Limite Aprovado" value={limiteAprovado} onChange={e => setLimiteAprovado(e.target.value)} />
                        )}
                        {exigePrazo && (
                            <Input type="number" min="0" step="1" label="Prazo Aprovado (dias)" value={prazoAprovado} onChange={e => setPrazoAprovado(e.target.value)} />
                        )}
                    </div>
                </div>
            )}

            <div className="flex justify-end gap-2 flex-wrap">
                {acoes.includes("REPROVAR") && (
                    <Button
                        variant={acaoInfo("REPROVAR").variant}
                        iconLeft={acaoInfo("REPROVAR").iconLeft}
                        label={acaoInfo("REPROVAR").label}
                        loading={acaoEmExecucao === "REPROVAR"}
                        disabled={(!!acaoEmExecucao && acaoEmExecucao !== "REPROVAR") || !justificativa.trim()}
                        onClick={() => executar("REPROVAR")}
                    />
                )}
                {podeAprovarParcial && (
                    <Button
                        variant={acaoInfo("APROVAR_PARCIAL").variant}
                        iconLeft={acaoInfo("APROVAR_PARCIAL").iconLeft}
                        label={acaoInfo("APROVAR_PARCIAL").label}
                        loading={acaoEmExecucao === "APROVAR_PARCIAL"}
                        disabled={(!!acaoEmExecucao && acaoEmExecucao !== "APROVAR_PARCIAL") || parcialDesabilitado}
                        onClick={() => executar("APROVAR_PARCIAL")}
                    />
                )}
                {acoes.includes("APROVAR") && (
                    <Button
                        variant={acaoInfo("APROVAR").variant}
                        iconLeft={acaoInfo("APROVAR").iconLeft}
                        label={acaoInfo("APROVAR").label}
                        loading={acaoEmExecucao === "APROVAR"}
                        disabled={(!!acaoEmExecucao && acaoEmExecucao !== "APROVAR") || !justificativa.trim()}
                        onClick={() => executar("APROVAR")}
                    />
                )}
            </div>
        </div>
    );
}
